export const typeOptions = [
    { id: 1, label: "Apartment" },
    { id: 2, label: "Independent House" },
    { id: 3, label: "Villa" },
    { id: 4, label: "Plot" },
    { id: 5, label: "Builder Floor" },
    { id: 6, label: "Penthouse" },
    { id: 7, label: "Studio Apartment" },
    { id: 8, label: "Farm House" },
];

export const minPriceOptions = [
    { id: 500000, label: "₹5,00,000" },
    { id: 1000000, label: "₹10,00,000" },
    { id: 1500000, label: "₹15,00,000" },
    { id: 2000000, label: "₹20,00,000" },
    { id: 2500000, label: "₹25,00,000" },
    { id: 3000000, label: "₹30,00,000" },
    { id: 4000000, label: "₹40,00,000" },
    { id: 5000000, label: "₹50,00,000" },
    { id: 6000000, label: "₹60,00,000" },
    { id: 7000000, label: "₹70,00,000" },
    { id: 8000000, label: "₹80,00,000" },
    { id: 9000000, label: "₹90,00,000" },
    { id: 10000000, label: "₹1 Crore" },
    { id: 15000000, label: "₹1.5 Crore" },
    { id: 20000000, label: "₹2 Crore" },
    { id: 25000000, label: "₹2.5 Crore" },
    { id: 30000000, label: "₹3 Crore" },
    { id: 40000000, label: "₹4 Crore" },
    { id: 50000000, label: "₹5 Crore" },
    { id: 75000000, label: "₹7.5 Crore" },
    { id: 100000000, label: "₹10 Crore" },
];

export const maxPriceOptions = [
        { id: 5000, label: '₹5,000' },
        { id: 7500, label: '₹7,500' },
        { id: 10000, label: '₹10,000' },
        { id: 12500, label: '₹12,500' },
        { id: 15000, label: '₹15,000' },
        { id: 17500, label: '₹17,500' },
        { id: 20000, label: '₹20,000' },
        { id: 25000, label: '₹25,000' },
        { id: 30000, label: '₹30,000' },
        { id: 35000, label: '₹35,000' },
        { id: 40000, label: '₹40,000' },
        { id: 45000, label: '₹45,000' },
        { id: 50000, label: '₹50,000' },
        { id: 60000, label: '₹60,000' },
        { id: 70000, label: '₹70,000' },
        { id: 80000, label: '₹80,000' },
        { id: 90000, label: '₹90,000' },
        { id: 100000, label: '₹1,00,000' },
        { id: 125000, label: '₹1,25,000' },
        { id: 150000, label: '₹1,50,000' },
        { id: 175000, label: '₹1,75,000' },
        { id: 200000, label: '₹2,00,000' },
    ];

    export const distanceOptions = [
            { id: 1, label: "1/4 mile" },
            { id: 2, label: "1/2 mile" },
            { id: 3, label: "1 mile" },
            { id: 4, label: "25 miles" },
        ];

        export const options= [
                { id: 1, label: "1 Bed" },
                { id: 2, label: "2 Beds" },
                { id: 3, label: "3 Beds" },
                { id: 4, label: "4 Beds" },
                { id: 5, label: "5 Beds" },
                { id: 6, label: "6 Beds" },
                { id: 7, label: "7 Beds" },
                { id: 8, label: "8 Beds" },
            ];